import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {AsyncTypeahead, Menu, MenuItem} from 'react-bootstrap-typeahead';

const LinkedItems = (props) => {
    const [addLinkedItemIsLoading, setAddLinkedItemIsLoading] = useState(false)
    const [addLinkedItemOptions, setAddLinkedItemOptions] = useState([])
    const [addLinkedItemSelected, setAddLinkedItemSelected] = useState([])

    const linkedItems = props.linkedItems || []
    const project_id = props.project_id
    const disabled = props.disabled
    const header = props.header
    const onChange = props.onChange

    const handleDeleteLinkedItem = (item) => {
        const updated = linkedItems.filter(function (i) {
            return i.id != item.id
        })
        onChange(updated)
    }

    let linkedItemsList = []
    if ( linkedItems ) {
        for (let item of linkedItems ) {
            let deleteItemButton = null
            if ( ! disabled ) {
                deleteItemButton = (
                    <button type="button" className="btn btn-xs btn-delete"
                        onClick={() => handleDeleteLinkedItem(item)}>Delete
                    </button>
                )
            }

            linkedItemsList.push(
                <li key={item.display_name} className="list-group-item">
                    <Link to={`/portfolio/${project_id}/${item.type}/${item.id}`}>{item.display_name}</Link>
                    &nbsp;
                    {deleteItemButton}
                </li>
            )
        }
    }

    let addLinkedItemForm = []
    // default to disabled field
    addLinkedItemForm.push(
        <input
            className="form-control"
            type="text"
            name="disabled-linked-item-form"
            disabled={disabled}
        />
    )

    if ( ! disabled ) {
        addLinkedItemForm = []
        addLinkedItemForm.push(
            <AsyncTypeahead
                id="typeahead"
                key="typeahead"
                placeholder="Start typing to search..."
                isLoading={addLinkedItemIsLoading}
                filterBy={(option, props) => {
                    return true
                }}
                minLength={2}
                useCache={false}
                renderMenu={(results, menuProps) => (
                    <Menu {...menuProps}>
                        {results.map(function(result, index) {
                            if( result.type == 'header' ) {
                                return (
                                    <li role="option" key={index}>
                                        <div className="dropdown-item">{result.display_name}</div>
                                    </li>
                                )
                            } else {
                                return (
                                    <MenuItem option={result} position={index} key={index}>
                                        {result.display_name}
                                    </MenuItem>
                                )
                            }
                        })}
                    </Menu>
                )}
                onChange={(selected) => {
                    onChange(linkedItems.concat(selected))
                    setAddLinkedItemSelected([])
                }}
                onSearch={query => {
                    setAddLinkedItemIsLoading(true)
                    fetch(`/v0/cadm_search?project_id=${project_id}&query=${query}`, { credentials: 'same-origin' })
                        .then(function(response) {
                            return response.json()
                        })
                        .then(function(json) {
                            json.results.forEach(function (element) {
                                element.label = element.display_name
                            })

                            // Clear already linked items
                            const options = json.results.filter(item => {
                                return ! linkedItems.find(linked => (item.type === linked.type && item.id === linked.id ))
                            })
                                
                            setAddLinkedItemIsLoading(false)
                            setAddLinkedItemOptions(options)
                        })
                }}
                options={addLinkedItemOptions}
                selected={addLinkedItemSelected}
            />
        )
    }

    return (
        <span>
            <div className="form-group">
                <label className="col-sm-2 control-label"></label>
                <div className="col-sm-8">
                    <label className="control-label">{header}</label>
                    <ul className="list-group clear-list m-t">
                        {linkedItemsList}
                    </ul>
                </div>
            </div>

            <div className="form-group">
                <label className="col-sm-2 control-label">Add</label>
                <div className="col-sm-8">
                    {addLinkedItemForm}
                </div>
            </div>
        </span>
    )
}

export default LinkedItems
